import React from "react";
import { cn } from "../../../../../../utils/classnames";

export const SectionTitleRow = ({ title }) => (
  <div className="tw:min-h-[36px] tw:py-2 tw:w-full tw:border-x tw:border-b tw:border-[#e8e8e8] tw:bg-[#f9f9f9] tw:px-5 tw:flex tw:items-center tw:justify-center">
    <div className="tw:text-[#8d8d8d] tw:text-[14px] tw:leading-[20px] tw:font-hanken-grotesk tw:text-center">{title}</div>
  </div>
);

export const LabelCell = ({ label, isFirst }) => (
  <div
    className={cn(
      "tw:w-[90px] tw:sm:w-[225px] tw:px-2 tw:sm:px-5 tw:py-[14px] tw:border-l tw:border-b tw:border-[#e8e8e8] tw:bg-white tw:flex tw:items-center",
      isFirst && "tw:rounded-bl-[5px]"
    )}
  >
    <div className="tw:text-[#8d8d8d] tw:text-[11px] tw:sm:text-[14px] tw:leading-[18px] tw:sm:leading-[20px] tw:font-hanken-grotesk">{label}</div>
  </div>
);

export const ValueText = ({ text, secondary, muted, bold, secondaryBold = false }) => (
  <div className="tw:flex tw:flex-col tw:!justify-center tw:gap-[2px] tw:w-full">
    {text && (
      <div
        className={cn(
          "tw:font-hanken-grotesk tw:text-[15px] tw:leading-[22px]",
          muted ? "tw:text-[#8d8d8d] tw:italic" : "tw:text-[#282828]",
          bold ? "tw:font-bold" : "tw:font-normal"
        )}
      >
        {text}
      </div>
    )}
    {secondary && (
      <div className="tw:flex tw:flex-col tw:gap-0.5">
        {(Array.isArray(secondary) ? secondary : [secondary]).map((line, i) => (
          <div key={i} className={cn("tw:text-[#7c7b7b] tw:text-[13px] tw:leading-[18.5px] tw:font-hanken-grotesk tw:font-normal", secondaryBold && "tw:font-bold")}>
            {line}
          </div>
        ))}
      </div>
    )}
  </div>
);

export const ValuePaxText = ({ text,muted, bold }) => (
  <div className="tw:flex tw:flex-col tw:justify-center tw:gap-[2px] tw:w-full">
    {text && (
      <div className="tw:flex tw:flex-col tw:gap-0.5">
        {(Array.isArray(text) ? text : [text]).map((line, i) => (
          <div
            key={i}
            className={cn(
              "tw:font-hanken-grotesk tw:text-[15px] tw:leading-[22px]",
              muted ? "tw:text-[#8d8d8d] tw:italic" : "tw:text-[#282828]",
              bold ? "tw:font-bold" : "tw:font-normal"
            )}>
            {line}
          </div>
        ))}
      </div>
    )}
  </div>
);

export const ValueCell = ({ children, changed, muted, isRight, isLast, className }) => (
  <div
    className={cn(
      "tw:flex-1 tw:min-h-[68px] tw:px-2 tw:sm:px-5 tw:py-[14px] tw:border-l tw:border-b tw:border-[#e8e8e8] tw:flex tw:items-center",
      changed ? "tw:bg-[#fff8e8]" : muted ? "tw:bg-[#f3f3f3]" : "tw:bg-white",
      isRight && "tw:border-r",
      isRight && isLast && "tw:rounded-br-[5px]",
      className
    )}
  >
    {children}
  </div>
);

export const ComparisonRow = ({ label, before, after, afterChanged, beforeMuted, afterMuted, lastRow }) => (
  <div className="tw:flex tw:w-full">
    <LabelCell label={label} isFirst={lastRow} />
    <ValueCell muted={beforeMuted}>{before}</ValueCell>
    <ValueCell changed={afterChanged} muted={afterMuted} isRight isLast={lastRow}>
      {after}
    </ValueCell>
  </div>
);
